import { atom } from 'jotai';
import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { UatsWithoutAmlisResponse } from './types';

export const pageAtom = atom(1);
export const pageSizeAtom = atom(100);

const fetchPage = async (page: number, pageSize: number) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  const response = await request.get<UatsWithoutAmlisResponse>(
    `/admin/uats_without_amlis?${params.toString()}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
};

export const [uatsWithoutAmlisAtom, uatsWithoutAmlisLoadableAtom] =
  atomWithLoadable((get) => {
    const page = get(pageAtom);
    const pageSize = get(pageSizeAtom);
    return fetchPage(page, pageSize);
  });
